import React from 'react';
import { useTranslation } from 'react-i18next';
import { getPrayerSourceLabel } from './PrayerSourceSelector';
import { usePrayerSource } from '../contexts/PrayerSourceContext';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { prayerSource } = usePrayerSource();
  const sourceLabel = getPrayerSourceLabel(prayerSource);

  return (
    <footer className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-4 text-center backdrop-blur-sm">
      <div className="container mx-auto">
        <p className="mb-1">{t('iftarTimekeeper')}</p>
        <p className="text-sm">
          {t('prayerTimesCalculatedAccordingTo')} {sourceLabel}
        </p>
        <p className="text-sm mt-1">
          {t('developedBy').replace('Azmir AB', '')}
          <a
            href="https://www.azmir.se"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold underline underline-offset-2 hover:text-purple-200 transition-colors"
          >
            Azmir AB
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;